import React, { useMemo } from "react";
import featured1 from "../../assets/featured-1.png";
import featured2 from "../../assets/featured-2.png";
import featured3 from "../../assets/featured-3.png";
import featured4 from "../../assets/featured-4.png";
import featured5 from "../../assets/featured-5.png";
import featured6 from "../../assets/featured-6.png";
import { Buttons } from "../Buttons";
import { server } from "../../utilis/constant";

const Featured = ({ products }) => {
  const featuredProducts = useMemo(() => {
    return products
      ?.filter((p) =>
        p.tags?.some((tag) => tag.trim().toLowerCase() === "featured products"),
      )
      ?.slice(0, 6);
  }, [products]);
  return (
    <div className="flex justify-center items-center flex-col gap-[3rem] py-[3rem] h-[100%]">
      <h1
        className="relative inline-block text-[50px] font-bold text-[#0A0A0A]
after:content-[''] after:absolute after:left-0 after:-bottom-2
after:w-full after:h-[3px] after:bg-black"
      >
        Featured Products
      </h1>
      <div className="flex justify-center items-center gap-[2rem] mt-[1rem]  px-[1rem] xl:px-[6rem] flex-wrap">
        {featuredProducts?.map((product) => (
          <div
            key={product.id}
            className="w-[280px] sm:w-[350px] lg:w-[450px] h-[220px] rounded-[20px] bg-[#FFFFFF] flex justify-start px-[1.5rem] items-center gap-[2rem] shadow-[4px_4px_20px_-1px_rgba(0,0,0,0.17)]"
          >
            <img
              src={`${server}/${product.image}`}
              alt={product.title}
              className="w-[100px] sm:w-[120px] lg:w-[155px] h-[155px] object-contain rounded-[12px] rounded-tr-[30px]"
            />
            <div className="flex flex-col gap-[0.5rem]">
              <h1 className="text-[16px] lg:text-[20px] font-bold text-[#000000] product-tabs ">
                {product.title}
              </h1>
              <div className="flex justify-start gap-1 text-[#D4AF37] text-2xl ">
                {"★".repeat(Math.floor(product.rating || 4))}
                {"☆".repeat(5 - Math.floor(product.rating || 4))}
              </div>
              <p className="text-[18px] font-medium text-[#0A0A0A] product-tabs">
                {product.price}
              </p>
              <button className=' product-tabs buttons w-[120px] py-[0.4rem] rounded-[33px] text-[#000000] text-[18px] [font-family:"Syne",sans-serif]'>
                Shop Now
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default Featured;
